export const LIST_COMMENT_MIN_NORMAL_COLUMNS = 1;
export const LIST_COMMENT_MAX_NORMAL_COLUMNS = 5;
export const LIST_COMMENT_MAX_CONTENT_LENGTH = 5000;
export const LIST_COMMENT_MAX_TITLE_LENGTH = 30;

export const LIST_COMMENT_MAX_CONTENT_LENGTH_MESSAGE =
    "コメントは" + LIST_COMMENT_MAX_CONTENT_LENGTH + "文字以内で入力してください";

export const LIST_COMMENT_MIN_COLUMNS_MESSAGE =
    "コメント列は最低" + LIST_COMMENT_MIN_NORMAL_COLUMNS + "列必要です";

export const LIST_COMMENT_DUPLICATE_TITLE_MESSAGE = "同じタイトルのコメント列が既に存在します";

export function isValidListCommentContentLength(content) {
    if (content == null || content === "") {
        return true;
    }
    return String(content).length <= LIST_COMMENT_MAX_CONTENT_LENGTH;
}

/**
 * 通常コメント列のタイトル重複チェック
 * - 空白は重複OK
 * - 投稿URL列との比較は無視（通常列同士のみ）
 */
export function isDuplicateNormalColumnTitle(title, columns, excludeColumnId = null) {
    const normalized = title == null ? "" : String(title).trim();
    if (normalized === "") {
        return false;
    }

    return (columns || []).some((column) => {
        if (column.column_type !== "normal") {
            return false;
        }
        if (excludeColumnId != null && String(column.column_id) === String(excludeColumnId)) {
            return false;
        }
        const existing = column.title == null ? "" : String(column.title).trim();
        if (existing === "") {
            return false;
        }
        return existing === normalized;
    });
}

/**
 * 通常列かつ非空タイトルを title => column で返す
 */
function buildNormalColumnMapByTitle(columns) {
    const map = {};
    (columns || []).forEach((column) => {
        if (column.column_type !== "normal") {
            return;
        }
        const title = column.title == null ? "" : String(column.title).trim();
        if (title === "" || map[title]) {
            return;
        }
        map[title] = column;
    });
    return map;
}

function isNumericOnlyColumn(column) {
    return Number(column && column.is_numeric_only) === 1;
}

/**
 * 移動時の同名コメント列候補
 * - transferable: 引き継ぎ選択可能なタイトル
 * - blockedNumeric: 移動先のみ数字のみ入力のため引き継ぎ不可のタイトル
 */
export function getCommentTransferCandidates(sourceColumns, targetColumns) {
    const sourceMap = buildNormalColumnMapByTitle(sourceColumns);
    const targetMap = buildNormalColumnMapByTitle(targetColumns);
    const transferable = [];
    const blockedNumeric = [];

    Object.keys(sourceMap).forEach((title) => {
        if (!targetMap[title]) {
            return;
        }
        // 移動先が数字のみ、移動元がそうでない場合は引き継ぎ不可
        if (isNumericOnlyColumn(targetMap[title]) && !isNumericOnlyColumn(sourceMap[title])) {
            blockedNumeric.push(title);
            return;
        }
        transferable.push(title);
    });

    return {
        transferable,
        blockedNumeric
    };
}

/**
 * 移動時に引き継ぎ選択可能な同名タイトル
 */
export function getTransferableCommentTitles(sourceColumns, targetColumns) {
    return getCommentTransferCandidates(sourceColumns, targetColumns).transferable;
}

export function getNumericOnlyTransferBlockedMessage(title) {
    return title + "は数字のみ入力のため移動できません";
}